// utils/crypto-utils.js

const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;

// Encode text to Uint8Array
function encodeText(text) {
  return new TextEncoder().encode(text);
}

// Decode Uint8Array to string
function decodeText(buffer) {
  return new TextDecoder().decode(buffer);
}

// Convert ArrayBuffer to base64 string
function arrayBufferToBase64(buffer) {
  const bytes = new Uint8Array(buffer);
  const binary = bytes.reduce((acc, b) => acc + String.fromCharCode(b), '');
  return btoa(binary);
}

// Convert base64 string to ArrayBuffer
function base64ToArrayBuffer(base64) {
  const binary = atob(base64);
  const len = binary.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes.buffer;
}

// Derive AES key from secret using SHA-256
async function deriveKey(secret) {
  const hashBuffer = await crypto.subtle.digest("SHA-256", encodeText(secret));
  return crypto.subtle.importKey("raw", hashBuffer, { name: "AES-CBC" }, false, ["encrypt", "decrypt"]);
}

// Encrypt payload object
export async function encryptPayload(plainObj, method) {
  if (!SECRET_KEY) throw new Error("SECRET_KEY is not defined in .env");

  const plainText = method === "get" ? plainObj : JSON.stringify(plainObj);
  const key = await deriveKey(SECRET_KEY);
  const iv = crypto.getRandomValues(new Uint8Array(16));

  const encryptedBuffer = await crypto.subtle.encrypt(
    { name: "AES-CBC", iv },
    key,
    encodeText(plainText)
  );

  // Combine IV + ciphertext
  const combined = new Uint8Array(iv.length + encryptedBuffer.byteLength);
  combined.set(iv);
  combined.set(new Uint8Array(encryptedBuffer), iv.length);

  return arrayBufferToBase64(combined.buffer); // return Base64 string
}

// Decrypt payload string
export async function decryptResponse(encryptedBase64) {
  if (!SECRET_KEY) throw new Error("SECRET_KEY is not defined in .env");

  const combinedBuffer = base64ToArrayBuffer(encryptedBase64);
  const encryptedBytes = new Uint8Array(combinedBuffer);

  const iv = encryptedBytes.slice(0, 16);
  const cipherBytes = encryptedBytes.slice(16);

  const key = await deriveKey(SECRET_KEY);

  const decryptedBuffer = await crypto.subtle.decrypt(
    { name: "AES-CBC", iv },
    key,
    cipherBytes
  );

  const decryptedText = decodeText(decryptedBuffer);
  try {
    return JSON.parse(decryptedText);
  } catch (error) {
    return decryptedText;
  }
}